import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/Icon';
import { RECENT_TRANSACTIONS, TRANSACTION_STATUS_LABELS } from '../mockData';

const initials = (name) =>
  name
    .split(' ')
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

const RecentTransactions = () => {
  const { t } = useTranslation();

  return (
  <section className="stats-card">
    <header className="stats-card-head">
      <div>
        <h3 className="stats-card-title">{t('statistics.transactions.title')}</h3>
        <p className="stats-card-subtitle">{t('statistics.transactions.subtitle')}</p>
      </div>
      <button type="button" className="stats-btn stats-btn--solid">
        <Icon name="eye" size={14} />
        {t('statistics.transactions.viewAll')}
      </button>
    </header>

    <ul className="stats-rows">
      {RECENT_TRANSACTIONS.map((tx) => (
        <li className="stats-row" key={tx.id}>
          <span className="stats-avatar">{initials(tx.name)}</span>
          <span className="stats-row-main">
            <span className="stats-row-title">{tx.name}</span>
            <span className="stats-row-sub">{tx.email}</span>
          </span>
          <span className={`stats-status stats-status--${tx.status}`}>
            {TRANSACTION_STATUS_LABELS[tx.status] || tx.status}
          </span>
          <span className="stats-row-meta">
            <span className="stats-row-amount">{tx.amount}</span>
            <span className="stats-row-sub">{tx.time}</span>
          </span>
          <button type="button" className="stats-row-more" aria-label="Действия">
            <Icon name="sliders" size={16} />
          </button>
        </li>
      ))}
    </ul>
  </section>
  );
};

export default RecentTransactions;
